<template>
    <!-- PROCESS CONTENT -->
    <div>
      <v-tabs
        v-model="process_tab"
      >
        <v-tab
          v-for="process_tab in process_data_tabs"
          :key="process_tab"
        >
          {{ $vuetify.lang.translator(process_tab) }}
        </v-tab>
      </v-tabs>
      <div
        
      >
      <v-tabs-items
        v-model="process_tab"
        :class="container_class"
      >
        <div >
          <span v-if="title" class="font-weight-black">{{ process.name }}</span>
          <v-tab-item>
            <!-- TITULO Y ACCIONES-->
            <div
              class="qmkey-process-data"
              v-if="actions"
            >
              
              <div
                v-if="isAdmin"
                class="qmkey-process-data-actions"
              >
                <v-btn icon><v-icon medium @click="editProcess">mdi-pencil</v-icon></v-btn>
                <v-btn icon><v-icon medium @click="beforeDeleteProcess">mdi-trash-can</v-icon></v-btn>
              </div>
            </div>
            <!-- DATOS -->
            <div>
              <v-row
                v-for="row in process_fields"
                :key="(row[0] || {}).id+'_'+(row[1] || {}).id+''"
                class="pa-1"
                dense
              >
                <v-col
                  v-for="col in row"
                  :key="col.id"
                  class="qmkey-process-data"
                >
                  <span :class="col.class? col.class : 'font-weight-bold'">{{ $vuetify.lang.translator(`views.processes.process_fields.${col.id}`) }}</span>
                  <span :class="col.class? col.class : 'font-weight-light'">{{ col.value}}</span>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <!-- PERMISSIONS -->
          <v-tab-item>
            <!-- HEADERS -->
            <v-row class="font-weight-bold">
              <v-col
                v-for="col in permission_input"
                :key="'edit_'+col.id"
                cols="3"
              >
                {{ $vuetify.lang.translator(`views.processes.permission_fields.${col.id}`) }}
              </v-col>
              <v-col cols="2" v-if="isAdmin"></v-col>
            </v-row>
            <v-row
              v-for="(proc, index) in process.qprocesspermission_set"
              :key="proc.id"
            >
              <!-- LIST PERMISSIONS class="qmkey-process-permition-list" style="text-align: center;"-->
              <v-col
                v-for="col in permission_input"
                :key="'edit_'+col.id"
                :class="col.class"
                cols="3"
              >
                {{  readable_value(proc, col.id) }}
              </v-col>
              <v-col 
                v-if="isAdmin"
                class="d.flex"
                cols="2"
              >
                <v-icon
                  @click="beforeEditPermission(index,proc)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  @click="beforeDeletePermission(proc)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
            <!-- ADD PERMISSION -->
            <v-row v-if="isAdmin">
              <v-col
                class="qmkey-process-add-permission"
              >
                <v-icon
                  @click="beforeAddPermission"
                >
                  mdi-plus
                </v-icon>
              </v-col>
            </v-row>
          </v-tab-item>
        </div>
      </v-tabs-items>
      </div>
      <!-- PERMISSION FORM -->
      <ModalDialog
          :showModalDialog="show_dialog"
          :title="modal_title"
          :fields_to_collect="fields_to_collect"
          :submit_button_text="submit_button_caption"
          @close-dialog="toggle_dialog"
          @submit="submit_action"
          :validate="true"
      >
      </ModalDialog>
      <!-- DELETE CONFIRMATION -->
      <v-dialog
        v-model="confirmation_dialog"
        @input="submit_action"
      >
        <v-card>
          <v-card-title
            class="modal-card-title width-50"
          >
            <span class="qmkey-modal-h1 pb-0">{{ modal_title }}</span>
            <v-spacer></v-spacer>
            <v-btn
              class="qmkey-modal-dialog-close"
              text
              plain
              right
              small
              :ripple="false"
              @click="confirmation_dialog = false"
            >
              <v-icon :ripple="false" small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
            <v-btn
              class="qmkey-modal-dialog-button-secundary"
              text
              @click="toggle_confirmation"
            >
            {{ $vuetify.lang.translator('dialog.cancel') }}
            </v-btn>
            <v-btn
              class="qmkey-modal-dialog-button-submit"
              text
              @click="submit_action"
            >
            {{ $vuetify.lang.translator('dialog.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <style lang="scss">
    .qmkey-permission-title {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .qmkey-process-tabs-items {
      height: 100%;
      padding: 1vh;
      width: 100vh; 
    }
    .qmkey-process-data {
      display: flex;
      flex-direction: column;
    }
    .qmkey-process-data-actions {
      display: flex;
      justify-content: flex-end;
    }
    .qmkey-process-permition-list {
      text-wrap: wrap;
      overflow-wrap: break-word;
      white-space: wrap;
      min-inline-size: 100px;
      max-inline-size: 250px;
    }
    .qmkey-process-add-permission {
      display: flex;
      justify-content: center;
    }
  </style>
  
  <script>
    import { mapGetters } from 'vuex'
    import ModalDialog from '@/components/explorer/ModalDialog'
    export default {
      name: 'ProcessesData',
  
      components: {
        ModalDialog,
      },
  
  
      props: {
        process: {},
        roles: {},
        departments: {},
        container_class: {defaul: ''},
        title: Boolean,
        actions: Boolean,
        tab: {default: 0},
      },
      
      data: () => ({
        confirmation_dialog: false,
        show_dialog: false,
        modal_title: 'Are you sure?',
        submit_button_caption: 'Yes',
        fields_to_collect: null,
        submit_action: (()=>{}),
        selected_permission: null,
        process_types: [
          {
            id: -2,
            value: 'C',
            name: 'views.processes.process_types.core',
            class: 'qmkey-static-node darken-1'
          },
          {
            id: -3,
            value: 'E',
            name: 'views.processes.process_types.strategic',
            class: 'qmkey-static-node darken-1'
          },
          {
            id: -4,
            value: 'S',
            name: 'views.processes.process_types.support',
            class: 'qmkey-static-node darken-1'
          }
        ],
        internal_type: [
          [
            'views.processes.internal_type.public',
            'Public'
          ],
          [
            'views.processes.internal_type.restricted',
            'Restricted'
          ]
        ],
        process_tab: 0,
        process_data_tabs: ['views.processes.tabs.data', 'views.processes.tabs.permissions'],
        inherit_permissions: [{id: true, name: 'confirm'},{id: false, name: 'denny'}],
      }),
  
      computed: {
        ...mapGetters(['isAdmin','sitePath']),
        process_fields() {
          return [
            [
              { 
                id: 'internal_type',
                name: "Internal Process Type",
                value:  this.translate_key((this.internal_type.find(it => it[0] == this.process['internal_type'] || 'public'))[0] )
              },
              {
                id: 'bp_reference',
                name: "Referencia interna",
                value: this.process['bp_reference']
              }
            ],
            [
              { 
                id: 'inherit_permissions',
                name: "Inherit Permissions",
                value: this.translate_key((this.inherit_permissions.find(it => it.id == (this.process || {})['inherit_permissions']) || {}).name) 
              },
              {
                id: 'reference',
                name: "Referencia",
                value: this.process['reference']
               }
            ],
            [
              { 
                id: 'name',
                name: "Nombre",
                value: this.process['name']
              },
              { 
                id: 'process_type',
                name: "Tipo de proceso",
                value: this.translate_key((this.process_types.find(proc => proc.value == (this.process || {})['process_type']) || {}).name)
              }
            ],
            [
              {
                id: 'description',
                name: "Descripción",
                value: this.process['description']
              },
              { 
                id: 'entries',
                name: "Entradas",
                value: this.process['entries']
              }
            ],
            [
              { 
                id: 'outputs',
                name: "Salidas",
                value: this.process['outputs']
              },
              { 
                id: 'activities',
                name: "Actividades",
                value: this.process['activities'] 
              }
            ],
            [
              { 
                id: 'objective',
                name: "Objetivo del proceso",
                value: this.process['objective']
              },
              { 
                id: 'scope',
                name: "Alcance",
                value: this.process['scope']
              }
            ],
            [
             {
                id: 'process_roles_text',
                name: "ROLES DEL PROCESO",
                value: "",
                class:"text-subtitle-1"
             }
            ],
            [
              {
                id: 'responsible_roles',
                name: "Roles responsables del proceso",
                value: this.roles_values_array('RESPONSIBLE')                
              }
            ],
            [
              {
                id: 'creator_roles',
                name: "Roles que pueden crear",
                value: this.roles_values_array('CREATOR') 
              },
              {
                id: 'editor_roles',
                name: "Roles editor del proceso",
                value: this.roles_values_array('EDITOR') 
              }
            ],
            
            [
              {
                id: 'reader_roles',
                name: "Roles lectores del proceso",
                value: this.roles_values_array('READER')
              }
            ],
            [
              {
                id: 'original_document_reader_roles',
                name: "Roles lectores del proceso. Descargar original",
                value: this.roles_values_array('ORIGINAL_DOCUMENT') 
              },
              {
                id: 'visor_pdf_reader_roles',
                name:"Roles lectores del proceso. Sin descarga",
                value: this.roles_values_array('PDF_READER') 
              }
            ],
          ];
        },
        permission_input() {
          return [{
              id:	"permission_id",
              label: this.translate_key("views.processes.permission_fields.permission_id"),
              required:	true,
              value:	(this.selected_permission || {}).permission_id,
              cols:	4,
              class:	null,
              component: "TextInput",
              readonly: !!(this.selected_permission || {}).permission_id,
            },{
              id:	"roles_allowed",
              label:	this.translate_key("views.processes.permission_fields.roles_allowed"),
              required:	false,
              value: (this.selected_permission || {}).roles_allowed,
              multiple: true,
              cols:	4,
              class:	null,
              component:	"AutocompleteSelect",
              items: this.roles.map(rol => [rol.value,rol.text]),
            },{
              id:	"departments_allowed",
              label:	this.translate_key("views.processes.permission_fields.departments_allowed"),
              required:	false,
              value: (this.selected_permission || {}).departments_allowed,
              multiple: true,
              cols:	4,
              class:	null,
              component:	"AutocompleteSelect",
              items: this.departments.map(dep => [dep.value,dep.text]),
            }]
        },
      },
  
      methods: {
        roles_values_array(id) {
          // const items = (this.process[id]||[])
          const items = (this.process.roles || {})[id] || []
          let value = '';
          if (items.length > 0) {
            value = items.map(it => this.roles.find(rol => rol.value == it).text).toString();
          }
          return value;
        },
        toggle_dialog() {
          this.show_dialog = !this.show_dialog;
        },
        toggle_confirmation() {
          this.confirmation_dialog = !this.confirmation_dialog;
        },
  
        readable_value(permission, value_id) {
          const permission_value = permission[value_id]
          if (value_id == 'roles_allowed') {
            return this.readable_roles(permission_value);
          } else if (value_id == 'departments_allowed') {
            return this.readable_departments(permission_value)
          } else {
            return permission_value;
          }
        },
        readable_roles(roles) {
          return roles.map(dep => (this.roles.find(it => it.value == dep) || {}).text).join(', ');
        },
  
        readable_departments(departments) {
          return departments.map(dep => this.departments.find(it => it.value == dep).text).join(', ');
        },
  
        // TODO: Add possible rules into modal inputs
        validatePermissionId: function(value){
          if ( !value ) {
            this.validPermissionId = false
            return this.$vuetify.lang.translator('required_field')
          }
          var v = true
          this.validPermissionId = true
          // for (var permission in this.edit_process.qprocesspermission_set)
          var permissions = this.edit_process.qprocesspermission_set
          var permission = null
          for (var i=0; i<permissions.length; i++){
            permission = this.edit_process.qprocesspermission_set[i]
            if (value == permission.permission_id){
              this.validPermissionId = false
              v = this.$vuetify.lang.translator('duplicate_value')
              break
            }
          }
          return v
        },
  
        /* PROCESS */
  
        editProcess() {
          this.$emit('edit_process');
        },
        beforeDeleteProcess() {
          this.modal_title = `${this.$vuetify.lang.translator('views.processes.delete_process')} ${this.process.name} ?`;
          this.submit_action = () => this.deleteProcess();
          this.toggle_confirmation();
        },
        deleteProcess() {
          this.toggle_confirmation();
          this.$emit('delete_process');
        },
  
        /* PERMISSIONS */
        beforeAddPermission() {
          this.selected_permission = null;
          this.fields_to_collect = [this.permission_input];
          this.submit_button_caption = this.$vuetify.lang.translator('dialog.save');
          this.modal_title = this.$vuetify.lang.translator('views.processes.add_permission');
          this.submit_action = (form_data) => this.addPermission(form_data);
          this.toggle_dialog();
        },
        async addPermission(form_data) {
          console.log('addPermission',form_data)
          let data = this.form_data_to_obj(form_data);
          data.process = this.process.id;
          await this.$http
          .post(
            this.$base +
              '/api/v1' +
              this.sitePath +
              '/processpermission/',
            data,
          )
          .then(() => {
            this.$emit('refresh');
          })
          .catch(err => {
            console.error(err)
          })
          this.toggle_dialog();
        },
        beforeEditPermission(index, selected) {
          this.selected_permission = Object.assign(selected, {pos: index})
          this.selected_permission = selected;
          this.submit_button_caption = this.$vuetify.lang.translator('dialog.save');
          this.modal_title = this.$vuetify.lang.translator('views.processes.edit_permission');
          this.submit_action = (form_data) => this.editPermission(form_data);
          this.$nextTick(()=> {
            this.fields_to_collect = [this.permission_input];
            this.toggle_dialog();
          });
        },
        async editPermission(form_data) {
          let data = this.form_data_to_obj(form_data);
          data.process = this.process.id;
          let process_to_edit = this.process;
          const current_qrocesspermission = process_to_edit.qprocesspermission_set[this.selected_permission.pos];
          process_to_edit.qprocesspermission_set[this.selected_permission.pos] = {...current_qrocesspermission,...data};
          await this.$http.put(
            this.$base +
              '/api/v1' +
              this.sitePath +
              '/process/' +
              process_to_edit.id +
              '/',
            process_to_edit,
          )
          .then(() => {
            this.loading = false
            this.getProcesses()
            this.showEditProcessModal = false
          })
          .catch(err => {
            this.render_form_errors(err)
          })
          this.toggle_dialog();
        },
        beforeDeletePermission(selected) {
          this.selected_permission = selected;
          this.modal_title = `${this.$vuetify.lang.translator('views.processes.delete_permission')} ${selected.permission_id} ?`;
          this.submit_action = (form_data) => this.deletePermission(form_data);
          this.toggle_confirmation();
        },
        async deletePermission() {
          await this.$http
            .delete(
              this.$base +
              '/api/v1' +
              this.sitePath +
              '/processpermission/' +
              this.selected_permission.id +
              '/',
            )
            .then(() => {
              this.$emit('refresh');
            })
            .catch(err => {
              console.error(err);
            })
          this.toggle_confirmation();
        },
  
        form_data_to_obj(form_data) {
          let permission_obj = {}
  
          form_data.forEach((value, key) => permission_obj[key] = value);
          for(let permission_field of this.permission_input) {
            if (permission_field.component == 'AutocompleteSelect') {
              // String to array of integers, lis of id's
              if(permission_obj[permission_field.id]) {
                permission_obj[permission_field.id] = JSON.parse(permission_obj[permission_field.id])
              } else {
                permission_obj[permission_field.id] = [];
              }
              
            }
          }
          return permission_obj;
        },

        translate_key(k) {
          if (!k) {
            return "";
          }
          return this.$vuetify.lang.translator(k);
        }
      },
  
      watch: {
      },
  
    }
  </script>